import React, { useEffect, useState } from 'react';
import { ArrayChecker, Pagination } from '../../../components';
import qs from 'query-string'
import DesktopLayout from './page-desktop-layout';
import SearchForm from './form-sidebar';
import CollectionNav from './collection-nav';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { SystemProvider } from '../../system/provider';
import { QueryChips } from '../../../components/chip';
import ListFilterHeader from '../../../components/dashboard-listing/list-filter-header';
import { List as ListOrganization } from '../../../pages/organization/components';
import adapterOrganization from '../../organization/adapter';
import { List as ListProgram } from '../../../pages/program/components';
import adapterProgram from '../../program/adapter';
import { List as ListEvent } from '../../../pages/event/components';
import adapterEvent from '../../event/adapter';
import { List as ListResource } from '../../../pages/resource/components';
import adapterResource from '../../resource/adapter';
import { List as ListBlog } from '../../../pages/blog/components';
import adapterBlog from '../../blog/adapter';
import { DESKTOP_ITEMS_PER_PAGE } from '../config';

const DEFAULT_ITEMS_PER_PAGE = 5
const DEFAULT_SORT_OPTIONS = ['date']
const itemsPerPageConfig = DESKTOP_ITEMS_PER_PAGE

const PageResultDesktop = ({onSort, customNav, filterOptions}) => {
  const history = useHistory()
  const location = useLocation()
  const { search, pathname } = location
  const query = qs.parse(search)
  const data = useSelector(state => state.search.queryResults.results)
  const { totalResults, collection } = useSelector(state => state.search)
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE)
  const [pageIndexes, setPageIndexes] = useState([0, DEFAULT_ITEMS_PER_PAGE])
  const sortOptions = collection === 'organizations' ? [...DEFAULT_SORT_OPTIONS, 'name'] : [...DEFAULT_SORT_OPTIONS, 'title']

  useEffect(() => {
    const finalItemsPerPage = itemsPerPageConfig[collection] ?
      itemsPerPageConfig[collection] : DEFAULT_ITEMS_PER_PAGE;
    setItemsPerPage(finalItemsPerPage)
    setPageIndexes([0, finalItemsPerPage])
  }, [collection])

  useEffect(() => {
    const currentParams = new URLSearchParams(location.search)
    if(currentParams.get('limit') !== String(itemsPerPage)){
      currentParams.set('limit', itemsPerPage)
      history.replace(location.pathname + '?' + currentParams.toString())
    }
    // eslint-disable-next-line
  }, [itemsPerPage])

  const handlePaginationChange = (newPage) => {
    console.log('[B] handle pagination change!')
    const limit = itemsPerPage
    const offset = limit*(newPage-1)

    const newQuery = {
      ...query,
      limit,
      offset
    }

    // Set pagination info
    const startIndex = (newPage-1)*itemsPerPage
    const endIndex = startIndex + itemsPerPage
    setPageIndexes([startIndex, endIndex])

    console.log('[B] history pushing...')
    history.push({
      pathname,
      search: qs.stringify(newQuery)
    })
  }

  return (
    <DesktopLayout
      aside={<>
        <div className="lg:pr-12">
          <SystemProvider>
            <SearchForm options={filterOptions}/>
          </SystemProvider>
        </div>
      </>}
      main={<>
        {
          customNav ? customNav : <CollectionNav />
        }

        <ListFilterHeader
          pageIndexes={pageIndexes}
          totalData={totalResults}
          query={query}
          sortOptions={sortOptions}
          onSort={onSort}
        />

        <SystemProvider>
          <div className="mb-8">
            <QueryChips />
          </div>
        </SystemProvider>

        <ArrayChecker data={data}>
          <>
            {
              collection === 'organizations' &&
              <ListOrganization data={data?.map(d => adapterOrganization.responseBodyToRender(d))}/>
              // <DevLogger data={data?.map(d => d.organisasiId)}/>
            }
            {
              collection === 'programs' &&
              <ListProgram data={data?.map(d => adapterProgram.responseBodyToRender(d))}/>
            }
            {
              collection === 'events' &&
              <ListEvent data={data?.map(d => adapterEvent.responseBodyToRender(d))}/>
            }
            {
              collection === 'resources' &&
              <ListResource data={data?.map(d => adapterResource.responseBodyToRender(d))}/>
            }
            {
              collection === 'blogs' &&
              <ListBlog data={data?.map(d => adapterBlog.responseBodyToRender(d))}/>
            }
          </>
        </ArrayChecker>

        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={totalResults}
          defaultCurrentPage={1}
          onChange={handlePaginationChange}
        />
      </>}
    />
  )
}

export default PageResultDesktop
